import useLocalStore from 'src/store/useLocalStore';

import NumberBadge from 'src/components/NumberBadge';

const MAX_DISPLAY_COUNT = 50;
const MAX_DISPLAY_TEXT = '50+';

interface GradingReceivedNumberBadgeProps {
  className?: string;
}

const GradingReceivedNumberBadge = ({
  className,
}: GradingReceivedNumberBadgeProps) => {
  const { gradingReceivedCount } = useLocalStore();

  return (
    !!gradingReceivedCount && (
      <NumberBadge
        number={
          gradingReceivedCount > MAX_DISPLAY_COUNT
            ? MAX_DISPLAY_TEXT
            : gradingReceivedCount
        }
        className={className}
      />
    )
  );
};

export default GradingReceivedNumberBadge;
